export default "__VITE_ASSET__By8i5Ykr__"